import { apiGet } from "../../API/Service/apiClient";

export const handleGet_HomePage = async (  
  {setLogos}
  ) => {    
    let data={}
  try {
    const resData = await apiGet("partners_logos", data);         
    setLogos(resData?.data)    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {      
  }
};